module.exports = __webpack_public_path__ + "img/20200619_161041.4a229ff3.jpg";